import Enum from "./Enum";
import NewUserOnboardingStepV3 from "./NewUserOnboardingStepV3";
import InvitedUserOnboardingStepV3 from "./InvitedUserOnboardingStepV3";

const onboardingVersions = {
	// keeping v1 here in case we ever have to use it for
	// legacy data manipulation
	3: isTeamLead => isTeamLead ?
		NewUserOnboardingStepV3 :
		InvitedUserOnboardingStepV3,
};

const enumFor = ( { version, isTeamLead = true, } ) => {
	const resolver = onboardingVersions[ version ] || ( () => Enum.empty );
	return resolver( isTeamLead );
};

const isValidStep = ( { step, version, isTeamLead = true, } ) => {
	const OnboardingSteps = enumFor( version, isTeamLead );
	return OnboardingSteps.includes( step );
};

export default {
	enumFor,
	isValidStep,
};
